<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepLaunch2',
})
</script>
<template>
  <TlDetailItem :title="title" color="blue">
    <TlDetailField label="报告函">
      <FileDisplayNormals :files="record?.report2Files ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="会议纪要">
      <FileDisplayNormals :files="record?.meetingFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="参保人员名单">
      <FileDisplayNormals :files="record?.nameListFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <div class="mt-24">
      <Table
        size="small"
        :columns="previewColumns"
        :data-source="previewDataSource"
        :pagination="false"
        :scroll="{ x: 'max-content', y: 500 }"
        :row-key="getPreviewRowKey"
      />
    </div>
    <TlDetailField label="矢量范围">
      <FileDisplayNormals :files="record?.areaFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="土地款分配明细表">
      <FileDisplayNormals :files="record?.fenPeiFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="公示表">
      <FileDisplayNormals :files="record?.gongShiFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="公示照片">
      <FileDisplayNormals :files="record?.gongShiPicFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="参保登记表">
      <FileDisplayNormals :files="record?.canBaoDengJiFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="情况说明">
      <FileDisplayNormals :files="record?.qingKuangFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepLaunch2">
import { Table } from 'ant-design-vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
import { computed } from 'vue'
const props = defineProps<{
  record?: any
  isRenew?: boolean
}>()
const title = computed(() => (props.isRenew ? '重新发起' : '发起') + '-人员名单复核')
const previewDataSource = computed(() => props.record?.securityFilesView ?? [])
const previewColumns = computed(() => {
  const firstRow = previewDataSource.value[0] ?? {}
  return Object.keys(firstRow).map(key => ({
    title: key,
    dataIndex: key,
    key,
    ellipsis: true
  }))
})
const getPreviewRowKey = (record: Record<string, any>, index: number) => record.id ?? record.ID ?? record.序号 ?? String(index)
</script>
